var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comment_wrap tip" }, [
    _c("h4", { staticClass: "sp" }, [
      _vm._v(_vm._s(_vm.$t("cop.common.username-search-guide.msg1")))
    ]),
    _vm._v(" "),
    _c("ol", [
      _c("li", [
        _c("strong", [
          _vm._v(_vm._s(_vm.$t("cop.common.username-search-guide.msg2")))
        ]),
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("cop.common.username-search-guide.msg3")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [
          _vm._v(_vm._s(_vm.$t("cop.common.username-search-guide.msg4")))
        ]),
        _vm._v(
          "\n      " + _vm._s(_vm.$t("cop.common.username-search-guide.msg5"))
        ),
        _c("br"),
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("cop.common.username-search-guide.msg6")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [
          _vm._v(_vm._s(_vm.$t("cop.common.username-search-guide.msg7")))
        ]),
        _vm._v(
          "\n      " + _vm._s(_vm.$t("cop.common.username-search-guide.msg8"))
        ),
        _c("br"),
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("cop.common.username-search-guide.msg9")) +
            "\n    "
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17be74b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17be74b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tooltip/UserNameSearchGuideTooltip.vue
// module id = 5iAK
// module chunks = 410